<template>
    <div class="audio-library">
        <!-- 筛选按钮区域 -->
        <div class="status-filter-btns">
            <div class="status-buttons">
                <button class="status-btn selected">All audio</button>
            </div>
            <div class="unseen-filter">
                <label class="toggle-switch">
                    <input type="checkbox" v-model="showOnlyUnseen" @change="handleUnseenFilterChange">
                    <span class="toggle-slider"></span>
                    <span class="toggle-label">Show only unseen</span>
                </label>
            </div>
        </div>

        <!-- 音频列表 -->
        <ul class="audio-list" v-infinite-scroll="loadMore" :infinite-scroll-disabled="isLoading || isNoMore"
            :infinite-scroll-distance="50">
            <li :class="['audio-item', { 'is-selected': item.isClicked }]" v-for="(item, i) in audioList" :key="i"
                @click="toggleSelect(item)" @mouseenter="item.isHovered = true" @mouseleave="item.isHovered = false"
                :style="{ cursor: getCursorStyle(item) }">
                <div class="audio-container" :class="{ 'disabled-audio': isDisabled(item) }">
                    <!-- 音频播放图标 -->
                    <i class="el-icon-headset pointer" @click.stop="toggleAudioPlay(i)"
                        style="font-size: 50px; color: #999;"></i>

                    <!-- 音频名称 -->
                    <div class="audio-name">
                        <template v-if="item.isEditingName">
                            <input v-model="item.editingName" />
                            <div class="edit-btn-group">
                                <button class="edit-btn save" @click.stop="saveAudioName(item)">保存</button>
                                <button class="edit-btn cancel" @click.stop="cancelEditAudioName(item)">取消</button>
                            </div>
                        </template>
                        <template v-else>
                            <span class="audio-title-inline">
                                {{ item.originalName }}
                                <i class="el-icon-edit pointer" style="margin-left: 6px;"
                                    @click.stop="editAudioName(item)"></i>
                            </span>
                        </template>
                    </div>

                    <!-- 图标容器 -->
                    <div class="media-icons-container">
                        <!-- 标签图标 -->
                        <el-tooltip placement="top" effect="light" :content="getTagDescription(item)"
                            v-if="getIsShowTag(item)">
                            <div class="media-tag audio-tag">
                                <img :src="getTagIcon(item)" class="tag-icon" />
                            </div>
                        </el-tooltip>
                        <!-- 是否发送过 -->
                        <el-tooltip placement="top" effect="light" :content="'发送过'" v-if="item.casualStatus == 'sent'">
                            <div class="media-tagSec">
                                <i class="el-icon-s-promotion" style="color: #fff;font-size: 18px;"></i>
                            </div>
                        </el-tooltip>
                        <!-- 是否查看过 -->
                        <el-tooltip placement="top" effect="light" :content="'已听过'"
                            v-if="item.casualStatus == 'accessed'">
                            <div class="media-tagSec" style="background: rgba(255, 255, 255, 0.7) !important;">
                                <img src="@/assets/svg/listened.svg" style="width: 14px;">
                            </div>
                        </el-tooltip>
                        <!-- 调试：显示casualStatus值 -->
                        <!-- <div v-if="item.casualStatus" style="position: absolute; top: -25px; left: 0; background: yellow; color: black; font-size: 10px; padding: 2px; z-index: 30;">
                            {{ item.casualStatus }}
                        </div> -->
                    </div>

                    <!-- 灰色蒙版 -->
                    <div v-if="shouldShowOverlay(item)" class="disabled-overlay"></div>
                </div>

                <!-- 选中状态指示 -->
                <div class="selection-indicator" v-if="item.isClicked">
                    <i class="el-icon-success" style="color: #5FAAFF;"></i>
                </div>
            </li>

            <!-- 加载状态 -->
            <li v-if="isLoading" class="loading-item">
                <img class="loading-icon" src="@/assets/loading.gif" alt="">
            </li>

            <!-- 无更多数据 -->
            <li v-if="isNoMore && !isLoading" class="no-more-item">
                没有更多了
            </li>
        </ul>

        <!-- 音频播放弹窗 -->
        <el-dialog :visible.sync="audioPlayerShow" width="40%" :before-close="closeAudioPlayer" :modal="true"
            :close-on-click-modal="true" :modal-append-to-body="true" :append-to-body="true"
            custom-class="audio-player-modal" :title="currentAudioData?.originalName || '音频播放'">
            <div class="audio-player-dialog" v-if="currentAudioData">
                <div class="audio-container">
                    <div class="audio-icon">
                        <i class="el-icon-headset" style="font-size: 80px; color: #2499FF; margin-bottom: 20px;"></i>
                    </div>
                    <audio ref="dialogAudioPlayer" controls autoplay :src="currentAudioData.url"
                        @loadeddata="playAudioInDialog">
                        <source :src="currentAudioData.url" type="audio/mpeg">
                        <source :src="currentAudioData.url" type="audio/mp3">
                        您的浏览器不支持音频播放
                    </audio>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getConnectionAudios, sendForModeration, updateAudioName } from '@/api/talkytimes/message'


export default {
    name: 'AudioLibrary',
    props: {
        chatUserInfo: {
            type: Object,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            default: false
        },
        approvedOnly: {
            type: Boolean,
            default: false
        },
        currentMessageType: {
            type: String,
            default: 'chat'
        },
        showApprovedOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            audioList: [],
            // Show only unseen 筛选条件
            showOnlyUnseen: true,
            limit: 50,
            cursor: '',
            isLoading: false,
            isNoMore: false,
            hasError: false, // 添加错误状态标志
            audioPlayerShow: false,
            currentAudioData: null,
            currentAudioIndex: -1
        }
    },
    computed: {
    },
    watch: {
        showOnlyUnseen: {
            handler(newVal, oldVal) {
                // 避免初始化时触发
                if (oldVal !== undefined) {
                    this.refresh();
                }
            }
        },
        chatUserInfo: {
            handler(newVal, oldVal) {
                // 当聊天用户信息变化时，刷新数据
                if (newVal && oldVal && newVal.userId !== oldVal.userId) {
                    this.refresh();
                }
            },
            deep: true
        },
        currentMessageType: {
            handler(newVal, oldVal) {
                // 当消息类型切换时，重新调整媒体库数据
                if (oldVal !== undefined && newVal !== oldVal) {
                    this.refresh();
                }
            }
        }
    },
    mounted() {
        // 音频默认开启 showOnlyUnseen
        this.showOnlyUnseen = true;
        this.loadAudios();
    },
    methods: {
        // 加载音频数据
        async loadAudios(isLoadMore = false) {
            if (this.isLoading) return;
            // 如果有错误且不是加载更多，直接返回
            if (this.hasError && !isLoadMore) return;

            this.isLoading = true;
            this.hasError = false; // 重置错误状态

            let idInterlocutor = this.chatUserInfo.userId || this.chatUserInfo.idInterlocutor || this.chatUserInfo.id_user || this.chatUserInfo.id;

            // 获取自己的用户ID (pdUserId)
            const activeUser = localStorage.getItem('activeUser');
            const pdUserId = activeUser ? JSON.parse(activeUser).id : null;

            // 如果是管理模式且 idInterlocutor 无效，使用 pdUserId
            if ((this.currentMessageType === 'management' || this.editMode) && (!idInterlocutor || idInterlocutor === 'default')) {
                idInterlocutor = pdUserId;
            }

            // 验证 idInterlocutor 是否有效
            if (!idInterlocutor || idInterlocutor === 'default') {
                console.error('无法获取有效的用户ID');
                this.isLoading = false;
                this.hasError = true;
                return;
            }

            try {
                // 使用新的连接音频接口，构建请求参数
                const params = {
                    idInterlocutor: Number(idInterlocutor),
                    limit: this.limit,
                    statuses: ['approved']
                };

                // 添加pdUserId（如果有值）
                if (pdUserId) {
                    params.pdUserId = Number(pdUserId);
                }

                // Show only unseen 筛选条件
                // 音频的 excludeConnectionStatuses 只有 accessed，打开时传，不打开时不传
                if (this.showOnlyUnseen) {
                    params.excludeConnectionStatuses = ['accessed'];
                }

                // 分页参数
                if (isLoadMore && this.cursor) {
                    params.cursor = String(this.cursor);
                }

                const res = await getConnectionAudios(params);
                // 新格式：数据在 res.data 中
                const audiosData = res.data || res;
                const audioArr = Array.isArray(audiosData.audios) ? audiosData.audios : [];

                const newAudios = audioArr.map(item => {
                    if (!item) return null;
                    return {
                        ...item,
                        id: item.id || item.idAudio,
                        idAudio: item.id || item.idAudio,
                        url: item.urls?.mp3 || item.url,
                        originalName: item.title || '音频',
                        fileCateType: 3,
                        isClicked: false,
                        isHovered: false,
                        status: typeof item.status === 'string' ? { code: item.status } : item.status,
                        casualStatus: item.connectionStatus || item.casualStatus, // 从 connectionStatus 获取
                        isEditingName: false,
                        editingName: ''
                    };
                }).filter(Boolean); // 过滤掉 null 值

                if (isLoadMore) {
                    this.audioList = this.audioList.concat(newAudios);
                } else {
                    this.audioList = newAudios;
                }

                // 新格式：cursor 在 res.data.cursor 中
                this.cursor = audiosData.cursor || '';
                this.isNoMore = newAudios.length < this.limit;

            } catch (error) {
                console.error('加载音频失败:', error);
                // 请求失败时，设置错误状态并清空列表（仅首次加载时）
                if (!isLoadMore) {
                    this.hasError = true;
                    this.audioList = [];
                    this.isNoMore = true; // 停止后续加载
                }
            } finally {
                this.isLoading = false;
            }
        },

        // 加载更多
        loadMore() {
            if (!this.isLoading && !this.isNoMore && !this.hasError) {
                this.loadAudios(true);
            }
        },

        // 刷新数据
        refresh() {
            this.cursor = '';
            this.isNoMore = false;
            this.hasError = false; // 重置错误状态
            this.audioList = [];
            this.loadAudios();
        },

        // 切换选择状态
        toggleSelect(item) {
            if (!this.canSelect(item)) return;

            this.$set(item, 'isClicked', !item.isClicked);

            if (item.isClicked) {
                this.$emit('item-selected', item);
            } else {
                this.$emit('item-deselected', item);
            }
        },

        // 判断是否可以选中
        canSelect(item) {
            if (this.editMode) return true;
            if (!item) return false;

            // 处理 status 字段，兼容字符串和对象格式
            const statusValue = typeof item.status === 'string' ? item.status : (item.status?.code || '');
            
            // Declined/On moderation 状态禁止选中
            if (statusValue && (statusValue.includes('declined') || statusValue.includes('on_moderation'))) {
                return false;
            }

            // 新接口返回的数据已经过滤，可以直接选中
            return true;
        },

        // 获取鼠标样式
        getCursorStyle(item) {
            if (this.editMode) return 'pointer';
            if (!this.canSelect(item)) return 'not-allowed';
            return 'pointer';
        },

        // 判断是否禁用
        isDisabled(item) {
            return !this.canSelect(item);
        },

        // 判断是否显示蒙版
        shouldShowOverlay(item) {
            if (!item) return false;
            if (this.editMode) return false;

            // 处理 status 字段，兼容字符串和对象格式
            const statusValue = typeof item.status === 'string' ? item.status : (item.status?.code || '');
            
            // Declined/On moderation 状态显示蒙版
            if (statusValue && (statusValue.includes('declined') || statusValue.includes('on_moderation'))) {
                return true;
            }
            
            // 新接口返回的数据已经过滤，不需要显示蒙版
            return false;
        },

        // 处理 unseen 筛选条件变化
        handleUnseenFilterChange() {
            this.refresh();
        },

        // 是否显示标签
        getIsShowTag(item) {
            if (!item) return false;
            const statusValue = typeof item.status === 'string' ? item.status : (item.status?.code || '');
            // 音频通常不显示内容标签，只显示状态标签
            if (statusValue && statusValue.includes('declined')) {
                return true;
            }
            if (statusValue === 'on_moderation') {
                return true;
            }
            return false;
        },

        // 获取标签图标
        getTagIcon(item) {
            if (!item) return '';
            const statusValue = typeof item.status === 'string' ? item.status : (item.status?.code || '');
            if (statusValue && statusValue.includes('declined')) {
                return require('@/assets/svg/negative.svg');
            } else if (statusValue === 'on_moderation') {
                return require('@/assets/svg/clock.svg');
            }
            return '';
        },

        // 获取标签描述
        getTagDescription(item) {
            if (!item) return '';
            const statusValue = typeof item.status === 'string' ? item.status : (item.status?.code || '');
            if (statusValue && statusValue.includes('declined')) {
                return '审核不通过';
            } else if (statusValue === 'on_moderation') {
                return '审核中';
            }
            return '';
        },

        // 是否显示重新审核按钮
        shouldShowReReview(item) {
            if (!item) return false;
            const statusValue = typeof item.status === 'string' ? item.status : (item.status?.code || '');
            if (!statusValue) return false;
            if (typeof statusValue === 'string' && statusValue.includes('declined')) return true;
            if (statusValue === 'on_moderation') return true;
            return false;
        },

        // 重新审核
        async reReview(item) {
            try {
                await sendForModeration({ idAudio: item.idAudio });
                this.$message.success('重新提审成功');
                this.refresh();
            } catch (error) {
                this.$message.error('重新提审失败');
            }
        },

        // 音频播放相关方法
        toggleAudioPlay(index) {
            this.currentAudioIndex = index;
            this.currentAudioData = this.audioList[index];
            this.audioPlayerShow = true;
        },

        closeAudioPlayer() {
            this.audioPlayerShow = false;
            this.currentAudioData = null;
            this.currentAudioIndex = -1;
        },

        playAudioInDialog() {
            this.$nextTick(() => {
                const audio = this.$refs.dialogAudioPlayer;
                if (audio) {
                    audio.play();
                }
            });
        },

        // 音频名称编辑相关方法
        editAudioName(item) {
            this.audioList.forEach(v => v.isEditingName = false); // 只允许一个编辑
            this.$set(item, 'isEditingName', true);
            this.$set(item, 'editingName', item.originalName);
        },

        async saveAudioName(item) {
            try {
                await updateAudioName({
                    idAudio: item.id,
                    title: item.editingName
                });
                this.$message.success('修改成功');
                item.isEditingName = false;
                item.originalName = item.editingName;
            } catch (error) {
                this.$message.error('修改失败');
            }
        },

        cancelEditAudioName(item) {
            item.isEditingName = false;
        },

        // 删除选中项
        async deleteItems(items) {
            console.log('AudioLibrary - deleteItems called:', items);

            if (!items || items.length === 0) {
                console.log('没有要删除的项目');
                return;
            }

            try {
                // 调用删除API
                const itemIds = items.map(item => item.id || item.idAudio);
                console.log('要删除的音频ID:', itemIds);

                // 注意：目前没有音频删除API，只做本地删除
                // TODO: 当有音频删除API时，取消下面的注释
                // for (const id of itemIds) {
                //     await deleteAudio({ idAudio: id });
                // }

                // 从当前列表中移除选中的项目
                this.audioList = this.audioList.filter(audio => {
                    const audioId = audio.id || audio.idAudio;
                    const shouldKeep = !itemIds.includes(audioId);
                    if (!shouldKeep) {
                        console.log('删除音频:', audio);
                    }
                    return shouldKeep;
                });

                console.log('删除后的音频列表长度:', this.audioList.length);

                // 显示删除成功消息
                this.$message.success(`成功删除 ${items.length} 个音频`);

            } catch (error) {
                console.error('删除音频失败:', error);
                this.$message.error('删除失败，请重试');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.audio-library {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.status-filter-btns {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 16px 0;
    padding: 0 8px;

    .status-buttons {
        display: flex;
        gap: 12px;
    }

    .status-btn {
        padding: 8px 20px;
        border: 2px solid #e4e7ed;
        border-radius: 20px;
        background: #fff;
        color: #606266;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

        &:hover {
            border-color: #67c23a;
            color: #67c23a;
            transform: translateY(-1px);
            box-shadow: 0 4px 8px rgba(103, 194, 58, 0.15);
        }

        &.selected {
            background: linear-gradient(135deg, #67c23a 0%, #5daf34 100%);
            border-color: #67c23a;
            color: #fff;
            box-shadow: 0 4px 12px rgba(103, 194, 58, 0.3);
            transform: translateY(-1px);
        }
    }

    .unseen-filter {
        display: flex;
        align-items: center;
    }

    .toggle-switch {
        position: relative;
        display: inline-flex;
        align-items: center;
        cursor: pointer;

        input[type="checkbox"] {
            display: none;
        }

        .toggle-slider {
            position: relative;
            width: 44px;
            height: 24px;
            background-color: #ccc;
            border-radius: 24px;
            transition: background-color 0.3s;
            margin-right: 8px;

            &::before {
                content: '';
                position: absolute;
                width: 18px;
                height: 18px;
                border-radius: 50%;
                background-color: white;
                top: 3px;
                left: 3px;
                transition: transform 0.3s;
            }
        }

        input:checked + .toggle-slider {
            background-color: #67c23a;

            &::before {
                transform: translateX(20px);
            }
        }

        .toggle-label {
            font-size: 14px;
            color: #606266;
            user-select: none;
        }
    }
}

.audio-list {
    flex: 1;
    height: 100%;
    width: 100%;
    display: block;
    padding: 0;
    margin: 0;
    list-style: none;
    overflow-y: auto;

    .audio-item {
        position: relative;
        display: inline-block;
        margin: 3px;
        padding: 10px;
        vertical-align: top;
        box-sizing: border-box;
        text-align: center;
        border: 1px solid transparent;
        transition: all 0.2s;

        &.is-selected {
            border: 1px solid #2499FF;
            border-radius: 8px;
        }

        .audio-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 150px;
            height: 100px;
            position: relative;

            &.disabled-audio {
                opacity: 0.6;
            }

            .disabled-overlay {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: rgba(128, 128, 128, 0.3);
                pointer-events: none;
                z-index: 5;
            }

            .audio-name {
                margin-top: 10px;
                font-size: 16px;
                color: #333;
                display: flex;
                flex-direction: column;
                align-items: flex-start;

                .audio-title-inline {
                    display: flex;
                    align-items: center;
                }

                input {
                    font-size: 16px;
                    padding: 4px 8px;
                    border-radius: 6px;
                    border: 1px solid #ccc;
                    margin-bottom: 8px;
                    width: 120px;
                    text-align: center;
                }

                .edit-btn-group {
                    display: flex;
                    gap: 10px;
                    justify-content: center;
                    width: 100%;
                }

                .edit-btn {
                    padding: 4px 16px;
                    border: none;
                    border-radius: 6px;
                    font-size: 15px;
                    cursor: pointer;
                    margin-bottom: 0;
                    transition: background 0.2s, color 0.2s;

                    &.save {
                        background: #2499ff;
                        color: #fff;

                        &:hover {
                            background: #176fd6;
                        }
                    }

                    &.cancel {
                        background: #f7f9fa;
                        color: #333;
                        border: 1px solid #eee;

                        &:hover {
                            background: #e4e4e4;
                        }
                    }
                }
            }

            .media-icons-container {
                position: absolute;
                bottom: 8px;
                left: 8px;
                display: flex;
                align-items: center;
                gap: 4px;
                z-index: 20;
            }

            .media-tag,
            .media-tagSec {
                position: relative;
                background: rgba(20, 20, 20, 0.4);
                color: white;
                width: 20px;
                height: 20px;
                border-radius: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 2px;
                transition: all 0.3s ease;
                cursor: pointer;
                z-index: 21;

                .tag-icon {
                    width: 10px;
                    height: 10px;
                }

                &:hover {
                    background: rgba(20, 20, 20, .6);
                }

                &.audio-tag {
                    bottom: 8px;
                    left: 8px;
                }
            }
        }

        .selection-indicator {
            position: absolute;
            right: 0;
            top: 2px;
        }
    }

    .loading-item,
    .no-more-item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        width: 100%;
        color: #999;
        font-size: 14px;

        .loading-icon {
            width: 30px;
            height: 30px;
            animation: rotate360 1s linear infinite;
        }
    }
}

@keyframes rotate360 {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

// 音频播放弹窗样式
::v-deep .audio-player-modal {
    z-index: 9999 !important;
    border-radius: 30px;

    .el-dialog {
        z-index: 9999 !important;
    }

    .el-dialog__wrapper {
        z-index: 9999 !important;
    }
}

.audio-player-dialog {
    text-align: center;
    padding: 20px 0;

    .audio-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .audio-icon {
            margin-bottom: 20px;
        }

        audio {
            width: 100%;
            max-width: 400px;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            background: #f8f9fa;
        }
    }
}
</style>
